/** 报价模块 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/lgit/v1/{organizationId}/supplier-logistics-quotes',
  items: [
      // 供应商报价列表            post /v1/{organizationId}/supplier-logistics-quotes/pageList
      { key: 'getQuotesPageList', url: '/pageList', method: 'post' },
      // 供应商报价列表(新增)       post /v1/{organizationId}/supplier-logistics-quotes/add
      { key: 'addQuotesPageList', url: '/add', method: 'post' },
      // 供应商报价列表(编辑)       post /v1/{organizationId}/supplier-logistics-quotes/update
      { key: 'editQuotesPageList', url: '/update', method: 'post' },
      // 供应商报价列表(复制)       post /v1/{organizationId}/supplier-logistics-quotes/{id}/copy
      { key: 'copyQuotesPageList', url: '/{id}/copy', method: 'post' },
      // 供应商报价列表(详情)       get /v1/{organizationId}/supplier-logistics-quotes/{id}
      { key: 'viewQuotesPageList', url: '/{id}', method: 'get' },
      // 供应商报价列表(批量删除)    delete /v1/{organizationId}/supplier-logistics-quotes/delete
      { key: 'deleteQuotesPageList', url: '/delete', method: 'delete' },
      // 供应商报价列表(启用/禁用)   put /v1/{organizationId}/supplier-logistics-quotes/status
      { key: 'changeQuotesPageStatus', url: '/status', method: 'put' },

      // 供应商详情页   get /v1/{organizationId}/supplier-logistics-quotes/get-supplier-logistics-quote-list/{id}
      { key: 'getSupplierLogisticsQuoteList', url: '/get-supplier-logistics-quote-list/{id}', method: 'get' },
      // 获取 运费/其他费 页面左侧 卡片数据   get /v1/{organizationId}/supplier-logistics-quotes/get-fee-type-list
      { key: 'getFeeTypeCardData', url: '/get-fee-type-list?id={id}', method: 'get' },

      // 运费/其他费 页面左侧 新增卡片数据   post /v1/{organizationId}/supplier-logistics-quotes/add-fee-type
      { key: 'addFeeTypeCardData', url: '/add-fee-type', method: 'post' },
      // 运费/其他费 页面左侧 编辑卡片数据   post /v1/{organizationId}/supplier-logistics-quotes/update-fee-type
      { key: 'updateFeeTypeCardData', url: '/update-fee-type', method: 'post' },
      // 运费/其他费 页面左侧 删除卡片数据   post /v1/{organizationId}/supplier-logistics-quotes/delete-fee-type
      { key: 'deleteFeeTypeCardData', url: '/delete-fee-type', method: 'post' },
      // 运费/其他费 获取 页面右侧 列表数据   get /v1/{organizationId}/supplier-logistics-quotes/get-fee-type-detail-list/{supplierLogisticsQuoteFeeTypeId}
      { key: 'getFeeTypeDataList', url: '/get-fee-type-detail-list/{supplierLogisticsQuoteFeeTypeId}', method: 'get' },
      // 运费/其他费 保存 页面右侧 列表数据   post /v1/{organizationId}/supplier-logistics-quotes/add-fee-type-detail/{supplierLogisticsQuoteFeeTypeId}
      { key: 'confirmFeeTypeDataList', url: '/add-fee-type-detail/{supplierLogisticsQuoteFeeTypeId}', method: 'post' },
      // 运费/其他费 导入 页面右侧 列表数据   post /v1/{organizationId}/supplier-logistics-quotes/import-fee-type-detail/{supplierLogisticsQuoteFeeTypeId}
      { key: 'importFeeTypeDataList', url: '/import-fee-type-detail/{supplierLogisticsQuoteFeeTypeId}', method: 'post', cType: 2, timeout: 10 * 60 * 1000 },

      // 试算  post /v1/{organizationId}/supplier-logistics-quotes/calculate
      { key: 'calculateQuote', url: '/calculate', method: 'post' },

      // VIP客户 右侧客户列表            post /v1/{organizationId}/supplier-logistics-quotes/customer-relative/list
      { key: 'getVIPCustomerQuotes', url: '/customer-relative/list', method: 'post' },
      // VIP客户 右侧客户绑定            post /v1/{organizationId}/supplier-logistics-quotes/customer-relative/add
      { key: 'bindVIPCustomer', url: '/customer-relative/add', method: 'post' },
      // VIP客户 右侧客户解绑            post /v1/{organizationId}/supplier-logistics-quotes/customer-relative/delete
      { key: 'unbindVIPCustomer', url: '/customer-relative/delete', method: 'post' },
    ],
};
export default {
  ...generate(config),
};
